<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 1.5c-3.315 0-6 .375-6 3V12c0 .66.292 1.252.75 1.665V15c0 .412.338.75.75.75h.75c.412 0 .75-.338.75-.75v-.75h6V15c0 .412.338.75.75.75h.75c.412 0 .75-.338.75-.75v-1.335A2.24 2.24 0 0 0 15 12V4.5c0-2.625-2.685-3-6-3Zm4.245 2.243h-8.49C5.168 3.345 6.233 3 9 3c2.768 0 3.832.345 4.245.743Zm.255 1.5V7.5h-9V5.242h9Zm-.255 7.304-.217.203H4.972l-.217-.203A.726.726 0 0 1 4.5 12V9h9v3a.726.726 0 0 1-.255.547Z"/>
    <path d="M6.375 12a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm5.25 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
